import {Component,Injectable} from '@angular/core';
import { Headers,URLSearchParams,Response, Http, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import 'rxjs/Rx';
import {CookieService} from "angular2-cookie/services/cookies.service";
import * as glob from "./global_url";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS


@Injectable()
export class MamAdminService {

  private srv_url:string = glob.srv_url;

  constructor(private http:Http, private cookie : CookieService, private logger : Logger){

  }
  getUrl():string{
    return this.srv_url;
  }

  getCompanyAdminList():Observable<any>{
    var url_path = "/mgr/system/company/list";
    return this.get(url_path,null,null);
  }

  getCompanyList(pathValue:string,param:URLSearchParams):Observable<any>{
    var url_path = "/mgr/system/company";
    return this.get(url_path,null,param);
  }

  getCompanies(page:number, size:number):Observable<any>{
    var url_path = "/mgr/system/company";
    var param = new URLSearchParams();
    param.set('page', String(page));
    param.set('size', String(size));
    return this.get(url_path,null,param);
  }

  getCompanyListByCompanyType(type:number) {
    var url_path = "/mgr/system/company/type";
    return this.get(url_path,String(type),null);
  }

  //------------------------ AgentLog------------------------------------
  getAgentLogSearch(page:number, max:number, search:string, field:string, start:string, end:string, companyId : any){
    var url_path = "/mgr/log/agentlog";
    var params = new URLSearchParams();
    params.set('companyId', companyId);
    params.set('page', String(page));
    params.set('max', String(max));
    params.set('search_text', search);
    params.set('search_field', field);
    params.set('start', start);
    params.set('end', end);
    return this.get(url_path, null, params);
  }

  getAgentLogExcel(search:string, field:string, start:string, end:string){
    var url_path = "/mgr/log/agentlog/excel";
    var params = new URLSearchParams();
    params.set('search_text', search);
    params.set('search_field', field);
    params.set('start', start);
    params.set('end', end);
    return this.get(url_path, null, params);
  }

  getAgentLogGroupName(){
    var url_path = "/mgr/log/agentlog/groupName";
    var params = new URLSearchParams();
    return this.get(url_path, null, null);
  }



  getSetUpSearch(page:number, max:number, search:string, field:string, start:string, end:string, setupType:any, companyId : any) {
    var url_path = "/mgr/log/agentlog/setup";
    var params = new URLSearchParams();

    params.set('page', String(page));
    params.set('max', String(max));
    params.set('search_text', search);
    params.set('search_field', field);
    params.set('start', start);
    params.set('end', end);
	params.set('companyId', companyId);
    params.set('setup_type', setupType);

    return this.get(url_path, null, params);
  }

  getSetUpLogExcel(search:string, field:string, start:string, end:string, setupType:any) {
    var url_path = "/mgr/log/agentlog/setup/excel";
    var params = new URLSearchParams();
    params.set('search_text', search);
    params.set('search_field', field);
    params.set('start', start);
    params.set('end', end);
    params.set('setup_type', setupType);
    return this.post(url_path, null, params);
  }

  getFromToAgentLog(level:number, fromDate:string, toDate:string) {
    var url_path = "/agentlog/fromtoAgentLog";
    var params = new URLSearchParams();
    params.set("level", <any>level);
    params.set("fromDate", fromDate);
    params.set("toDate", toDate);

    return this.get(url_path, null, params);
  }
  //------------------------ AgentLog------------------------------------
  //------------------------ IssueLog------------------------------------
  getMdmLog():Observable<any>{
    var url_path = "/mdmlog/all";
    return this.get(url_path, null, null);
  }

  getMdmLogMain(page:number, max:number):Observable<any>{
    var url_path = "/mdmlog/listMain";
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  getMdmLogList(page:number, max:number, search:string, field:string, start:string, end:string) {
    var url_path = "/mgr/log/issue";
    var param = {
      page : page,
      max : max,
      search_text : search,
      search_field : field,
      start : start,
      end : end
    }
    var p_params = new URLSearchParams();
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  getMessageGroup() :Observable<any> {
    var url_path = "/mgr/log/issue/messageGroup";
    return this.get(url_path, null, null);
  }

  getIssueStatistics(companyId:number, periord:string) {
    var url_path = "/mgr/log/issue/statistics";
    var p_params = new URLSearchParams();
    p_params.set('period', periord);
    return this.get(url_path, String(companyId), p_params);
  }

  closeIssue(issueID:Number) {
    let url_path = "/mdmlog/"+ issueID + "/closed";
    var p_params = new URLSearchParams();
    return this.put(url_path, null, p_params);
  }

  fixedIssue(issueID:string) {
    let url_path = "/mdmlog/"+ issueID + "/fixed";
    var p_params = new URLSearchParams();
    return this.put(url_path, null, p_params);
  }


  getlogGroup():Observable<any>{
    var url_path = "/mdmlog/logGroup";
    var p_params = new URLSearchParams();
    return this.get(url_path, null, null);
  }

  getControlLogForDevice(page:number, max:number, deviceId:number){
    var url_path = "/mgr/log/control";
    var p_params = new URLSearchParams();
    p_params.set('page', String(page));
    p_params.set('max', String(max));
    return this.get(url_path, String(deviceId), p_params);
  }

  getControlLogForDeviceForIOS(page:number, max:number, search:string, field:string, start:string, end:string){
    var url_path = "/mgr/log/control/ios";
    var p_params = new URLSearchParams();
    p_params.set('page', String(page));
    p_params.set('max', String(max));
    p_params.set('start', start);
    p_params.set('end', end);
    p_params.set('search_text', search);
    p_params.set('search_field', field);
    return this.get(url_path, null, p_params);
  }

  getControlLogGroupName() {
    var url_path = "/mgr/log/control/logGroup";
    var p_params = new URLSearchParams();
    return this.get(url_path, null, p_params);
  }


  //------------------------ AuditLog ------------------------------------
  getAuditLogList(page:number, max:number, search:string, field:string, start:string, end:string) {
    var url_path = "/mgr/log/audit";
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      start : start,
      end : end,
      search_text : search,
      search_field : field
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  getAuditLogListByCompany(page:number, max:number, search:string, field:string, companyId:number, start:string, end:string) {
    var url_path = "/mgr/log/audit";
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      start : start,
      end : end,
      search_text : search,
      search_field : field
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, String(companyId), p_params);
  }

  getAuditlogExcel() {
    var url_path = '/mgr/log/audit/excel';
    return this.get(url_path, null, null);
  }

  getEntityName() {
    var url_path = '/mgr/log/audit/entity';
    return this.get(url_path, null, null);
  }

  getAuditLogPolicy(id:number) {
    var url_path = '/mgr/log/audit/auditPolicy';
    return this.get(url_path, String(id), null);
  }

  getAuditLogPolicyView(id:number) {
    var url_path = '/mgr/log/audit/auditPolicyDetailView';
    return this.get(url_path, String(id), null);
  }

  getAuditLogRead(pathValue:string, param:URLSearchParams):Observable<any>{
    var url_path = "/auditLog";
    return this.get(url_path, pathValue, param);
  }

  getAuditLogAll(pathValue:string, param:URLSearchParams):Observable<any>{
    var url_path = "/auditLog";
    return this.get(url_path, null, null);
  }

  getAuditLogDetail(pathValue:string, param:URLSearchParams):Observable<any>{
    var url_path = "/auditlog/auditPolicyDetailView";
    return this.get(url_path, pathValue, null);
  }
  getAuditLogSyncView() {
    var url_path = "/auditlog/syncAuditLogView";
    return this.get(url_path, null, null);
  }

  //------------------------ AuditLog ------------------------------------
  //------------------------ lost list  ------------------------------------
  /*getLostList(page:number, max:number, search:string, like:string, field:string):Observable<any>{
    var url_path = "/udevice/lostStolenList";
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchString : search,
      searchLike : like,
      searchField : field
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }*/

  getNewLostList(companyId:any, page:number, max:number, search:string, like:string, field:string):Observable<any>{
    var url_path = "/mgr/device/lostStolenList";
    var p_params = new URLSearchParams();
    var param = {
      companyId : companyId,
      page : page,
      max : max,
      searchString : search,
      searchLike : like,
      searchField : field
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }
  //------------------------ lost list  ------------------------------------
  //------------------------ device_install --------------------------------
  getOsStatus() {
    var url_path = "/udevice/osStatus";
    return this.get(url_path, null, null);
  }

  getDeviceStatus() {
    var url_path = "/udevice/cStatus";
    return this.get(url_path, null, null);
  }

  getAgentInstallData() {
    var url_path ='/udevice/vStatus';
    return this.get(url_path, null, null);
  }

  getDeptDeviceOs(){
    var url_path = "/udevice/deptDeviceOS";
    var p_params = new URLSearchParams();
    return this.get(url_path, null, null);
  }

  /*getOfficeStatistic(page:number, max:number) {
    var url_path = '/app/officeStatistics';
    var p_params = new URLSearchParams();
    p_params.set('page', <any>page);
    p_params.set('max', <any> max);
    return this.get(url_path, null, p_params);
  }*/

  getDeviceOsStatus(companyId :number){
    var url_path = '/mgr/device/osStatus';
    var p_params = new URLSearchParams();
    p_params.set('companyId',String(companyId));
    return this.get(url_path,null,p_params);
  }

  getDeviceConnectionStatus(companyId :number){
    var url_path = '/mgr/device/connectionStatus';
    var p_params = new URLSearchParams();
    p_params.set('companyId',String(companyId));
    return this.get(url_path,null,p_params);
  }

  getDeviceLastVersionStatus(companyId :number){
    var url_path = '/mgr/device/lastVersionStatus';
    var p_params = new URLSearchParams();
    p_params.set('companyId',String(companyId));
    return this.get(url_path,null,p_params);
  }

  getAttDeviceTypeStatus(companyId :number, list:any){
    var url_path = '/mgr/device/attDeviceTypeStatus';
    var p_params = new URLSearchParams();
    p_params.set('companyId',String(companyId));
    p_params.set("attList",list);
    return this.get(url_path,null,p_params);
  }

  getOfficeStatistic(companyId:any, page:number, max:number) {
    var url_path = '/mgr/app/officeStatistics';
    var p_params = new URLSearchParams();
    p_params.set('companyId',String(companyId));
    p_params.set('page', <any>page);
    p_params.set('max', <any> max);
    return this.get(url_path, null, p_params);
  }

  //------------------------ device_install --------------------------------
  //------------------------ tree_service ----------------------------------
  getUserTree(id:number, type:string, depth:number) {
    var url_path = '/userTree/tree';
    var p_params = new URLSearchParams();
    p_params.set('id', <any>id);
    p_params.set('type', type);
    p_params.set('depth', <any> depth);
    return this.get(url_path, null, p_params)
  }

  //------------------------ tree_service ----------------------------------

  //------------------------ notice ----------------------------------------
  getNoticeList(page:number, max:number, search:string, field:string) {
    var url_path = '/mgr/system/notice';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchString : search,
      searchField : Number(field)
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  insertNotice(notice:any) {
    var url_path = '/notice';
    return this.post_requestBody(url_path, null, notice);
  }

  deleteNotice(id:number){
    var url_path = '/notice';
    return this.del(url_path, String(id), null);
  }

  addNoticeTarget(attr_id : any, notice_id : number) {
    var url_path = '/mgr/system/notice/attribute';
    var p_params = new URLSearchParams();
    p_params.set('attrIds', attr_id);
    return this.post(url_path, String(notice_id) , p_params);
  }

  deleteNoticeTarget(attr_id:any, notice_id : number) {
    var url_path = '/mgr/system/notice/attribute/deleteTarget';
    var p_params = new URLSearchParams();
    p_params.set('attrIds', attr_id);
    return this.post(url_path, String(notice_id), p_params);
  }
  //------------------------ notice --------------------------------------------
  //------------------------ product device manage -----------------------------
  getProductDeviceList(page:number, max:number, search:string, like:string, field:string) {
    var url_path = '/productdevice';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchString : search,
      searchLike : like,
      searchField : field
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  insertProductDevice(productModel:any) {
    var url_path = '/productdevice';
    return this.post_requestBody(url_path, null, productModel);

  }

  updateProductDevice(id:number, productModel:any) {
    var url_path = '/productdevice';
    return this.put(url_path, String(id), productModel);
  }

  deleteProductDevice(id:string) {
    var url_path = '/productdevice';
    return this.del(url_path, String(id), null);
  }


  //------------------------ product device manage -----------------------------

  //------------------------ app manage ----------------------------------------
  getAppList(page:number, max:number, search:string, like:string, field:string, app_type:string) {
    var url_path = '/app';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchString : search,
      searchLike : like,
      searchField : field
    }
    let type_url : string;
    if(app_type == 'office') type_url = 'office';
    else if(app_type == 'white') type_url = 'white';
    else if(app_type == 'black') type_url = 'black';
    else type_url = 'none';
    this.logger.debug("type_url :", type_url);
    p_params = this.setParamHelper(param);
    return this.get(url_path, type_url , p_params);
  }

  getInstalledAppForDevice(deviceId:number, page:number, max:number) {
    var url_path = '/pkginfo/installedAppList';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      deviceId : deviceId
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null , p_params);
  }

  getBlackAppAppointment(appId:number, flag:boolean){
    var url_path = '/app/blackAppAppointment';
    var p_params = new URLSearchParams();
    var param = {
      appId : appId,
      flag : flag
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null , p_params);
  }

  getWhiteAppAppointment(appId:number, flag:boolean){
    var url_path = '/app/whiteAppAppointment';
    var p_params = new URLSearchParams();
    var param = {
      appId : appId,
      flag : flag
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null , p_params);
  }

  insertApp(kind:string, versionedApp:any) {
    var url_path = '/app';
    return this.post_requestBody(url_path, kind, versionedApp);
  }

  updateApp(appId:number, kind:string, versionedApp:any) {
    var url_path = '/app/' + kind;
    return this.put(url_path, String(appId), versionedApp);
  }

  deleteApp(appId:number, kind:string) {
    var url_path = '/app/' + kind;
    return this.del(url_path, String(appId), null);
  }


//------------------------ app manage ----------------------------------------

//------------------------ device condition -----------------------------------
  getDeviceCondition(page:number, max:number, start:string, end:string, search:string, like:string, field:string) {
    var url_path = '/udevice/deviceConditionSearch';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchDate : start,
      searchEndDate : end,
      searchText : search,
      searchLike : like,
      searchField : field,
      targetId : <any> 1,
      targetType : "C",
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  getInstallAppForDevice(deviceId:number) {
    var url_path = '/pkginfo/deviceall';
    var p_params = new URLSearchParams();
    p_params.set('deviceId', String(deviceId));
    return this.get(url_path, null, p_params);
  }

  getVersionedappListForDevice(deviceId:number,page:number,max:number) {
    var url_path = '/versionedapp/device';
    var p_params = new URLSearchParams();
    var param = {
      page: page,
      max: max,
      deviceId: String(deviceId)
    }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  getGroupDevice(attId:number,page:number,size:number){
    let url_path = '/mgr/device/attribute/'+attId;
    let p_params = new URLSearchParams();
    let param = {
      page: page,
      size: size
    }
    p_params = this.setParamHelper(param);
    return this.post(url_path, null, p_params);
  }

  getGroupDeviceBySearch(groupId:number,page:number,size:number, search:string, field:string){
    let url_path = '/mgr/device/attribute/search';
    let p_params = new URLSearchParams();
    let param = {
      page: page,
      size: size,
      search_text : search,
      search_field : field
    }
    p_params = this.setParamHelper(param);
    return this.post(url_path, String(groupId), p_params);
  }



  getDeviceByIdx(idx:string) {
    var url_path = '/mgr/device/searchByIdx';
    let p_params = new URLSearchParams();
    let param = { idx : idx }
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }


//------------------------ device condition -----------------------------------
//------------------------ certificate management -----------------------------
  getCertificationList(page:number, max:number, start:string, end:string, search:string, like:string, field:string) {
    var url_path = '/certificate';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchLike : like,
      searchString : search,
      searchField: field
    };
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  insertCertification(certificate:any) {
    var url_path = '/certificate';
    return this.post_requestBody(url_path, null, certificate);
  }

  deleteCertification(id:number) {
    var url_path = '/certificate';
    return this.del(url_path, String(id), null);
  }
//------------------------ certificate management -----------------------------
//------------------------ policy Resource management -------------------------
  getLocationAll() {
    var url_path = '/location/all';
    var p_params = new URLSearchParams();
    return this.get(url_path, null, null);
  }

  getLocationList(page:number, max:number, search:string, like:string, field:string) {
    var url_path = '/location';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchLike : like,
      searchString : search,
      searchField: field
    };
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }
  //------------------------ policy Resource management -------------------------
  getGps(id:number) {
    var url_path = '/gps';
    var p_params = new URLSearchParams();
    return this.get(url_path, String(id), p_params);
  }

  getGpsList(page:number, max:number, search:string, like:string, field:string) {
    var url_path = '/gps';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchLike : like,
      searchString : search,
      searchField: field
    };
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  getBeacon(id:number) {
    var url_path = '/beaconArea';
    var p_params = new URLSearchParams();
    return this.get(url_path, String(id), p_params);
  }

  getBeaconList(page:number, max:number, search:string, like:string, field:string) {
    var url_path = '/beaconArea';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchLike : like,
      searchString : search,
      searchField: field
    };
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  getAP(id:number) {
    var url_path = '/controlap';
    var p_params = new URLSearchParams();
    return this.get(url_path, String(id), p_params);
  }

  getApList(page:number, max:number, search:string, like:string, field:string) {
    var url_path = '/controlap';
    var p_params = new URLSearchParams();
    var param = {
      page : page,
      max : max,
      searchLike : like,
      searchString : search,
      searchField: field
    };
    p_params = this.setParamHelper(param);
    return this.get(url_path, null, p_params);
  }

  insertBeacon(beacon : any) {
    var url_path = '/beaconArea';
    return this.post_requestBody(url_path, null, beacon);
  }

  insertLocation(location : any) {
    var url_path = '/location';
    return this.post_requestBody(url_path, null, location);
  }

  insertGps(gps : any) {
    var url_path = '/gps';
    return this.post_requestBody(url_path, null, gps);
  }

  updateGPS(gps : any) {
    var url_path = '/gps';
    return this.put(url_path, null, gps);
  }

  insertAP(ap : any) {
    var url_path = '/controlap';
    return this.post_requestBody(url_path, null, ap);
  }

  deleteLocation(id:string) {
    var url_path = '/location';
    return this.del(url_path, id, null);
  }

  deleteAp(id:string) {
    var url_path = '/controlap';
    return this.del(url_path, id, null);
  }

  deleteGps(id:string) {
    var url_path = '/gps';
    return this.del(url_path, id, null);
  }

  deleteBeacon(id:string) {
    var url_path = '/beaconArea';
    return this.del(url_path, id, null);
  }

  //------------------------ policy Resource management -------------------------

  //------------------------ policy tree management -------------------------
  getPolicyOne(id:number) {
    var url_path = '/policy';
    return this.get(url_path, String(id), null);
  }
  getPolicyTree(type:number) {
    /*var url_path = '/policy/tree';
     var params = new URLSearchParams();
     params.set('type', String(type));
     return this.get(url_path, null, params);*/
    //var url_path = '/mgr/policy/all';
    var url_path = '/mgr/policy/type/'+type;
    return this.get(url_path, null, null);
  }

  getNewPolicyTree(companyId:number,type:number,diff:string){
    var url_path = "/mgr/policy/company/"+companyId;
    var params = new URLSearchParams();
    params.set('type', String(type));
    params.set('diff', diff);
    return this.get(url_path, null, params)
  }

  getPolicyAll() {
    var url_path = '/policy/all';
    return this.get(url_path, null, null);
  }
  //------------------------ policy tree management -------------------------
  //------------------------ policy condition management -------------------------
  getTargetPolicyConditionList(policyId:number) {
    //var url_path = '/condition';
    var url_path = "/mgr/policy/viewTargetPolicy";
    return this.get(url_path, String(policyId), null);
  }

  getPolicyConditionList(policyId:number, page:number, max:number) {
    var url_path = '/condition';
    var params = new URLSearchParams();
    params.set('policyId', String(policyId));
    params.set('page', String(page));
    params.set('max', String(max));
    return this.get(url_path, null, params);
  }

  getPriorityCondition(idx:string) {
    var url_path = '/condition/priorityCondition';
    var params = new URLSearchParams();
    params.set('idx', idx);
    return this.get(url_path, null, params);
  }

  // 정책트리 클릭시
  getPolicyTarget(policyId:string, page:number, max:number) {
    var url_path = '/target';
    var params = new URLSearchParams();
    params.set('policyId', policyId);
    params.set('page', String(page));
    params.set('max', String(max));
    return this.get(url_path, null, params);
  }

  //기본정책 저장
  saveToDeploy(id:number, pTarget:any) {
    var url_path = '/mgr/policy/save';
    return this.post_requestBody(url_path, String(id), pTarget);
  }
  /*saveToDeployForLocation(id:number, pTarget:any) {
   var url_path = '/policy/saveToDeployForLocation';
   return this.post_requestBody(url_path, String(id), pTarget);
   }*/
  //출입정책 저장.
  saveForLocation(id:number, item : any){
    let url_path = '/mgr/policy/saveForLocation/' + id;
    return this.post_requestBody(url_path, null, item);
  }

  getPolicyControlList(policyConditionId:number, page:number, max:number) {
    var url_path = '/control';
    var params = new URLSearchParams();
    params.set('policyConditionId', String(policyConditionId));
    params.set('page', String(page));
    params.set('max', String(max));
    return this.get(url_path, null, params);
  }

  getPolicyControlDefault(conditionId:number) {
    var url_path = '/control/defaultToCategory';
    return this.get(url_path, String(conditionId), null);
  }

  getPolicyControlToCategory(id:number, category:string, platform:any) {
    var url_path = '/control/categoryToPlatform';
    var params = new URLSearchParams();
    params.set('category', category);
    params.set('platform', platform);
    return this.get(url_path, String(id), params);
  }

  // insertPolicyCondition(mdmpcond:any) {
  //   var url_path = '/condition';
  //   return this.post(url_path, null, mdmpcond);
  // }
  updatePriority(idx:string) {
    var url_path = '/condition/priorityCondition';
    var params = new URLSearchParams();
    params.set('idx', idx);
    return this.get(url_path, null, params);
  }

  insertPolicyCondition(id:number, mdmpcond:any) {
    var url_path = '/condition/addedCondition';
    return this.post_requestBody(url_path, String(id), mdmpcond);
  }

  updatePolicyCondition(id:number, mdmpcond:any) {
    var url_path = '/condition';
    return this.put(url_path, String(id), mdmpcond);
  }


  deletePolicyCondition(id:number){
    var url_path = '/condition/removeCondition';
    return this.get(url_path, String(id), null);
  }

  deletePolicyTarget(ids:string,targetType:string) {
    if(targetType == "group"){
      var url_path = '/mgr/system/attribute/targetGroup';
      var params = new URLSearchParams();
      params.set('targetGroup', ids);
      return this.del(url_path, null, params);
    }else{
      var url_path = '/mgr/policy/deleteTarget';
      var params = new URLSearchParams();
      params.set('targetIdx', ids);
      params.set('targetType',targetType);
      return this.get(url_path, null, params);
    }


  }

  getDeviceByUserId(userID:number, page:number, size:number) {
    var url_path = '/mgr/device/user';
    var params = new URLSearchParams();
    params.set('page', String(page));
    params.set('size', String(size));
    return this.get(url_path, String(userID), params);
  }

  addedPolicyTarget(policyId : number,param : any){
    let url_path = "/policy/addedTarget";
    let params = param;
    return this.post_requestBody(url_path, String(policyId), params);
  }

  getGroupTarget(policyId: number){

    var url_path = "/mgr/policy/" + policyId + "/group";

    return this.get(url_path,null,null);

  }

  getPolicyTargetList(policyId: number,type : string, page?:number, size?:number ){
    let url_path = "/mgr/policy/" + policyId + "/"+type;
    if(page && size){

      let params = new URLSearchParams();
      params.set('page', String(page));
      params.set('size', String(size));
      return this.get(url_path,null,params);
    }else{
      return this.get(url_path,null,null);
    }
  }

  //새로운 타겟 저장..
  addTargetList(policyId : number, type : string , params : any){
    let url_path = "/mgr/policy/" + policyId + "/"+type;
    //return this.post_requestBody(url_path,null,params);
    return this.put(url_path,null,params);

  }

  //새로운 정책 배포..
  deployPolicyTarget(policyId : number,type :string, list: any){
    //let url_path = "/mgr/policy/deploy/" + policyId + "/"+type;
    let url_path = "/mgr/push/policy/" + policyId + "/"+type;
    return this.put(url_path,null,list);
  }

  getOfficeAppList(companyId:number){
    let url_path = "/mgr/app/company/"+ companyId +"/officeAppList";
    return this.get(url_path,null,null);
  }

  //------------------------ policy condition management -------------------------
  //------------------------ policy passing management -------------------------
  getPassingCondtionDetailList(pId:number){
    var url_path = '/passing/condition/detailList';
    var params = new URLSearchParams();
    params.set('pId', String(pId));
    return this.get(url_path, null, params);
  }

  getPassingPolicyTargetList(idx:string, type:string) {
    //return MdmPolicyTargetModel
    var url_path = '/passing/policy/listForTarget';
    var params = new URLSearchParams();
    params.set('idx', idx);
    params.set('type', type);
    return this.get(url_path, null, params);
  }

  insertPassingPolicy(MdmPolicyModel:any) {
    var url_path = '/passing/policy/addedPolicy';
    return this.post_requestBody(url_path, null, MdmPolicyModel);
  }

  detailListForCondition(policyId : number){
    var url_path = '/passing/condition/detailListForCondition';
    var params = new URLSearchParams();
    params.set('pId',String(policyId));
    return this.get(url_path,null,params);
  }

  //------------------------ policy passing manage ---------------------------------
  insertPolicy(policyModel:any) {
    //var url_path = '/policy/addedPolicy';
    this.logger.debug(policyModel,policyModel);
    let url_path = '/mgr/policy/'+String(policyModel.company);
    let params = new URLSearchParams();
    params.set('name', policyModel.name);
    params.set('type', policyModel.type);
    params.set('areaType', policyModel.areaType);
    params.set('policyDesc',policyModel.policyDesc);

    this.logger.debug("params",params);
    return this.post(url_path, null, params);
  }


  deletePolicy(id:number) {
    var url_path = '/policy';
    return this.del(url_path, String(id), null);
  }

  //------------------------ policy management ---------------------------------
  passingPolicyPublish(id:number, MdmPolicyPublishModel:any) {
    var url_path = '/policy/' + String(id) + '/publish';
    this.logger.debug("path :", url_path);
    return this.post_requestBody(url_path, null, MdmPolicyPublishModel);
  }

  //------------------------ policy management ----------------------------------

  //------------------------ remoteDevice management ----------------------------
  getDeviceBaseInfo(id:number) {
    //return device
    var url_path = '/udevice/udevices';
    return  this.get(url_path, String(id), null);
  }

  getDeviceResource(deviceId:number) {
    var url_path = '/resource';
    var params = new URLSearchParams();
    params.set('deviceId', String(deviceId));
    return this.get(url_path, null, params);
  }

  getLostDeviceInfo(deviceId:number) {
    //return string
    var url_path = '/lostdevice/info';
    var params = new URLSearchParams();
    params.set('deviceId', String(deviceId));
    return this.get(url_path, null, params);
  }

  getBackupState(deviceId:number) {
    var url_path = '/restore/date';
    var params = new URLSearchParams();
    params.set('deviceId', String(deviceId));
    return this.get(url_path, null, params);
  }

  //도난분실 신고/해제 실행
  getLostDeviceCommpandAct(commandType:string, deviceId:number) {
    var url_path = '/lostdevice';
    var params = new URLSearchParams();
    params.set('deviceId', String(deviceId));
    return this.get(url_path, commandType, params);
  }
  //------------------------ remoteDevice management ----------------------------


  //------------------------ push Manangement -----------------------------------
  remotePushByDevice(command:string, value:string, deviceIds:any) {
    let url_path = "/mgr/push/command/device"
    var params = new URLSearchParams();
    params.set('command', command);
    params.set('device_ids', deviceIds);
    params.set('value', value);
    return this.post(url_path, null, params);
  }

  // 앱배포
  // type : 0 - group 1 - user 2 - device
  // command : 삭제- APP_REMOVE   인스톨 - APP_INSTALL
  deployApp(app_id:number, type:any, command:string, list:any) {
    let deploy_type : string = "";
    var params = new URLSearchParams();
    this.logger.debug("---00-0> ", list);
    if(type == 0) {deploy_type = "group"; params.set('group_ids', list);}
    else if (type == 1) {deploy_type = "user"; params.set('user_ids', list);}
    else {deploy_type = "device"; params.set('device_ids', list);};

    let url_path = "/mgr/push/app/" + deploy_type;

    params.set('command', command);

    return this.post(url_path, String(app_id), params);
  }

  //단말종합현황 설치 관련 push  - 단말
  setStatus(device_id:number, command:string, args:any){
    let url_path = "/mgr/push/app/setStatus/" + device_id;
    let params = new URLSearchParams();
    params.set('command', command);
    params.set('args[]',args);
    return this.get(url_path, null, params);
  }


  //------------------------ push Manangement ------------------------------------

  //------------------------ deviceLocationInfo Manangement ----------------------
  getPositionLogList(deviceId:number, page:number, max:number) {
    var url_path = '/posilog';
    var params = new URLSearchParams();
    params.set('deviceId', String(deviceId));
    params.set('page', String(page));
    params.set('max', String(max));
    return this.get(url_path, null, params);
  }
  //------------------------ deviceLocationInfo Manangement ----------------------



  //------------------------ upload Manangement -----------------------------------
  upload(){
    // var url_path = '/upload/';
    // var params = new URLSearchParams();
    // params.set('file[]', fileName.files);
    // return this.post_multiPart(url_path, null, params);
    return this.srv_url+"/upload/";
  }


  //------------------------ upload Manangement ----------------------------------

  //------------------------ user Manangement ----------------------------------

  getUserList(targetId:number, targetType:string, page:number, max:number, search:string, like:string, field:string){
    var url_path = "/user/userClickList";
    var p_param = new URLSearchParams();
    var params = {
      targetId : targetId,
      targetType : targetType,
      page : page,
      max : max,
      searchString : search,
      searchLike : like,
      searchField : field
    }
    p_param = this.setParamHelper(params);
    return this.get(url_path, null, p_param);
  }

  insertUserInfo(user:any) {
    var url_path = '/user';
    return this.post_requestBody(url_path, null, user);
  }

  updateUserInfo(id:number, user:any) {
    var url_path = '/user';
    return this.put(url_path, String(id), user);
  }

  deleteUserInfo(id:number) {
    var url_path = '/user';
    return this.del(url_path, String(id), null);
  }

  passwordChecker(password:string) {
    var url_path = '/user/checkPassword';
    var p_param = new URLSearchParams();
    p_param.set('password', password);
    return this.get(url_path, null, p_param);
  }
  userNameChecker(username:string) {
    var url_path = '/user/checkUsername';
    var p_param = new URLSearchParams();
    p_param.set('username', username);
    return this.get(url_path, null, p_param);
  }

  userMembernumChecker(membernum:string,companyId:string) {
    var url_path = '/mgr/system/user/checkMembernum';
    var p_param = new URLSearchParams();
    p_param.set('membernum', membernum);
    p_param.set('companyId', companyId);
    return this.get(url_path, null, p_param);
  }

  getGroupUserList(attId: number, page: number, size: number){
    var url_path = '/mgr/system/user/attribute/'+attId;
    let p_param = new URLSearchParams();
    p_param.set('page', String(page));
    p_param.set('size', String(size));

    return this.get(url_path, null, p_param);
  }

  getGroupUserListBySearch(groupId: number, page: number, size: number, search:string, field:string){
    var url_path = '/mgr/system/user/group/search/' + groupId;
    let p_param = new URLSearchParams();

    p_param.set('page', String(page));
    p_param.set('size', String(size));
    p_param.set('search_text', search);
    p_param.set('search_field', field);
    //return this.get(url_path, null, p_param);
    return this.post(url_path, null, p_param);
  }

  getUserListByIdx(idx:string) {
    var url_path = '/mgr/system/user/searchByIdx';
    let p_param = new URLSearchParams();
    p_param.set('idx', String(idx));
    return this.get(url_path, null, p_param);
  }

  getAttributeTypeList(companyId : number, page: number, size: number){
    var url_path = '/mgr/system/attribute/type';
    let p_param = new URLSearchParams();
    p_param.set('companyId', String(companyId));
    p_param.set('page', String(page));
    p_param.set('size', String(size));
    return this.get(url_path, null, p_param);
  }

  getAttributeTypeAllList(companyId : number){
    var url_path = '/mgr/system/attribute/type/all';
    let p_param = new URLSearchParams();
    p_param.set('companyId', String(companyId));
    return this.get(url_path, null, p_param);
  }

  getAttributeValueAllList(companyId : number){
    var url_path = '/mgr/system/attribute/value/list';
    let p_param = new URLSearchParams();
    p_param.set('companyId', String(companyId));
    return this.get(url_path, null, p_param);
  }

  getAttributeValueTree(attId : number){
    var url_path = '/mgr/system/attribute/type/tree';
    let p_param = new URLSearchParams();
    p_param.set('attId', String(attId));
    return this.get(url_path, null, p_param);
  }

  getUserAttributeValueLists(userId : number){
    var url_path = '/mgr/system/attribute/user/'+userId;
    return this.get(url_path,null,null);
  }

  getUserAttributeValueListsAndRoots(userId : number){
    var url_path = '/mgr/system/attribute/userAttrRoot/'+userId;
    return this.get(url_path,null,null);
  }

  unLockUser(userId : number){
    var url_path = '/user/unlockUser';
    let p_param = new URLSearchParams();
    p_param.set('userId', String(userId));
    return this.get(url_path,null,p_param);
  }

  companyUserDownloadExcel(companyId: number){
    var url_path = '/mgr/system/user/company/download/excel';
    let p_param = new URLSearchParams();
    p_param.set('companyId', String(companyId));

    return this.get(url_path, null, p_param);
  }

  //경남은행 부서코드(속성에 있는)를 얻기위해서 추가한 서비스
  getInsaDeptCode(){
    var url_path = '/mgr/system/attribute/insaSync/codeList';
    return this.get(url_path, null, null);

  }
  //------------------------ user Manangement ----------------------------------
  //------------------------ admin Manangement ---------------------------------
  getAdminList(page:number, max:number, search:string, field:string) {
    var url_path = '/mgr/admin/adminUser/search';
    let param = this.setSearchParam(page, max, search, field);
    this.logger.debug(param);
    return this.get(url_path, null, param);
  }

  getAdmin(page:number, max:number) {
    var url_path = '/mgr/admin/adminUser';
    return this.get(url_path, null, this.setPageParam(page,max));
  }

  AdminRoleCheck() {
    var url_path = '/mgr/admin/adminUser/roleCheck';
    return this.get(url_path , null , null);
  }

  unlockAction(id:number) {
    var url_path = '/mgr/admin/adminUser/unlockAdmin';
    return this.get(url_path , String(id) , null);
  }


  // getAdminListCompany(id:number){
  //   var url_path = '/mgr/admin/adminUser';
  //   var params = new URLSearchParams();
  //   return this.get(url_path, String(id), null);
  // }

  insertAdmin(companyId:number, admin:any) {
    var url_path = '/mgr/admin/adminUser';
    return this.post_requestBody(url_path, String(companyId), admin);
  }

  updateAdmin(id:number, admin:any) {
    var url_path = '/mgr/admin/adminUser/' + id + '/update';
    return this.put(url_path, null, admin);
  }

  removeAdmin(id:number) {
    var url_path = '/mgr/admin/adminUser/' + id + '/delete';
    return this.put(url_path, null, null);
  }

  addManageCompany(adminId:number, companies:any) {
    var url_path = '/mgr/admin/adminUser/addManageCompany';
    let p_param = new URLSearchParams();
    p_param.set('companies', companies);
    return this.post(url_path, String(adminId), p_param);
  }

  getManageCompany(adminId:number) {
    var url_path = '/mgr/admin/adminUser/manageCompany';
    return this.get(url_path, String(adminId), null);
  }

  getExcludeManageCompany(adminId:number) {
    var url_path = '/mgr/admin/adminUser/nonManageCompany';
    return this.get(url_path, String(adminId), null);
  }

  updateManageCompany(adminId:number) {
    var url_path = '/mgr/admin/adminUser/updateManageCompany';
    let p_param = new URLSearchParams();
    return this.post(url_path, String(adminId), p_param);
  }

  nonSetCompany() {
    var url_path = '/mgr/admin/adminUser/nonSetCompany';
    let p_param = new URLSearchParams();
    return this.get(url_path, null, null);
  }

  adminIdCheck(admin_id:string) {
    var url_path = '/mgr/admin/adminUser/checkId';
    let p_param = new URLSearchParams();
    p_param.set('username', admin_id);
    return this.get(url_path, null, p_param);
  }
  notUseCheck(admin_id: string) {
    var url_path = '/mgr/admin/adminUser/notUseCheck';
    let p_param = new URLSearchParams();
    p_param.set('admin_id', admin_id);
    return this.get(url_path, null, p_param);
  }
//------------------------ usertitle Manangement -----------------------------
  getUserTitle() {
    var url_path = '/userTitle';
    return this.get(url_path, null, null);
  }
  //------------------------ usertitle Manangement -----------------------------
  //------------------------ policy schedule Manangement -----------------------------
  getPolicySchedule(page:number, max:number, search:string, like:string, field:string) {
    var url_path = '/scheduleArea';
    var params = new URLSearchParams();
    params.set('page', String(page));
    params.set('max', String(max));
    params.set('searchString', search);
    params.set('searchField', field);
    params.set('searchLike', like);
    return this.get(url_path, null, null);
  }

  insertPolicySchedule(policyScheduleModel:any) {
    var url_path = "/scheduleArea";
    return this.post_requestBody(url_path, null, policyScheduleModel);
  }

  updatePolicySchedule(id:number, policyScheduleModel:any) {
    var url_path = "/scheduleArea";
    return this.put(url_path, String(id), policyScheduleModel);
  }

  deletePolicySchedule(id:number, policyScheduleModel:any[]) {
    var url_path = "/scheduleArea";
    return this.del(url_path, String(id), null);
  }











  //------------------------ display main -------------------------
  getMdmLogStatistics(type:string) {
    var url_path = '/mdmlog/statistics';
    var param = new URLSearchParams();
    param.set('period', type);
    return this.get(url_path, null, param);
  }

  getPolicyApplyData() {
    var url = '/udevice/policyApply';
    return this.get(url,null,null);
  }

  getPolicyApplyDataByCompany(companyId : number) {
    var url = '/udevice/policyApply';
    return this.get(url,String(companyId),null);
  }

  getRootingDeviceCountCompany(companyId:number){
    let url = "/mgr/device/rootStatus";
    let params = new URLSearchParams();
    params.set("companyId",String(companyId));
    return this.get(url,null,params);
  }

  getRootingDeviceCompany(companyId:number){
    let url = "/mgr/device/rootDevice";
    return this.get(url,String(companyId),null);
  }

  getRemoveProfileLog(companyId:number){
    let url = "/mgr/log/control/getRemoveProfile";
    return this.get(url,String(companyId),null);
  }
  //------------------------ display main --------------------------------------


  //------------------------ login(session) manager ----------------------------
  getLogin() {
    var url_path = '/login/admin';
    return this.get(url_path, null, null);
  }

  logOut() {
    var url_path = '/logout';
    return this.get(url_path, null, null);
  }

  loginAction(data:any)   {
    var url_path = '/auth';
    var param = new URLSearchParams();
    param.set('m_username', data.m_username);
    param.set('m_password', data.m_password);
    return this.post_login(url_path, null, param);
  }

  getSessionAdminUser() {
    var url_path = '/login/sessionInfo';
    var param = new URLSearchParams();
    return this.post(url_path, null, null);
  }

  getUserInfo() {
    var url_path = '/login/userInfo';
    var param = new URLSearchParams();
    return this.get(url_path, null, null);
  }

  getSessionConfig() {
    var url_path = '/login/user/sessionConfig';
    var param = new URLSearchParams();
    return this.get(url_path, null, null);
  }

  timeout() {
    var url_path = '/login/user/timeout';
    var param = new URLSearchParams();
    return this.get(url_path, null, null);
  }


  getAdminInfo() {
    var url_path = '/mgr/admin/adminUser/adminInfo'
    var params = new URLSearchParams();
    return this.get(url_path, null, null);
  }

  // setting property
  getConfigInfo(page:number, max:number) {
    var url_path = "/configuration";
    var params = new URLSearchParams();
    params.set('page', String(page));
    params.set('max', String(max));
    return this.get(url_path, null, params);
  }

  getConfigInfoByName(name:string) {
    var url_path = '/configuration';
    return this.get(url_path, name, null);
  }

  updateConfigInfo(id:number, SettingsProperty:any) {
    var url_path = '/configuration';
    return this.get(url_path, String(id), SettingsProperty);
  }

  updateAll(ids:string, values:string) {
    var url_path = '/configuration/updateAll';
    var params = new URLSearchParams();
    params.set('ids', ids);
    params.set('values', values);
    return this.get(url_path, null, params);
  }

  insertConfigInfo(SettingsProperty:any) {
    var url_path = '/configuration';
    return this.get(url_path, null, SettingsProperty);
  }

  // ------------- 사용자동의
  userConfirm() {
    var url_path = '/userConfirm';
    return this.get(url_path, null, null);
  }

  updateUserConfirm(confirm:string) {
    var url_path = '/userConfirm';
    var params = new URLSearchParams();
    params.set('contents', confirm);
    return this.post(url_path, null, params);

  }

  // ------------- download
  getDownload() {
    var url_path = '/mgr/download/agent';
    var params = new URLSearchParams();
    return this.get(url_path, null, params);
  }


  //--------------------- 임시 사용 ------------------------------------------//
  insertUserTemp(user:any) {

    var url_path = '/mgr/system/user/adminCopy';
    return this.post_requestBody(url_path, null, user);
  }
  // updateUserTemp(userId:number, user:any) {
  //   var url_path = '/mgr/system/user/updateCopyAdmin';
  //   return this.put(url_path, null, user);
  // }
  //----------------------임시 사용 ------------------------------------------//



  // otp history
  getOTPHisotrySearch(page:number, max:number, search:string, field:string, start:string, end:string){
    var url_path = '/mgr/log/smsAuth';
    var params = new URLSearchParams();
    params.set('page', String(page));
    params.set('max', String(max));
    params.set('start', String(start));
    params.set('end', String(end));
    params.set('search_field', String(field));
    params.set('search_text', String(search));
    return this.get(url_path, null, params);

  }

  //-------------------------- db sync history log ----------------------------------
  getDBSyncLogList(page:number, max:number, search:string, field:string, start:string ,end:string) {
    var url_path = '/mgr/log/dbSync';
    var params = new URLSearchParams();
    params.set('page', String(page));
    params.set('max', String(max));
    params.set('start', String(start));
    params.set('end', String(end));
    params.set('search_field', String(field));
    params.set('search_text', String(search));
    return this.get(url_path, null, params);
  }
  //-------------------------- db sync history log ----------------------------------

  //-------------------------- db sync restart ----------------------------------
  startDBSync(type:string,date:any) {
    var url_path = '/expansion/mdmRestart';
    var params = new URLSearchParams();
    params.set('type',String(type));
    params.set('date',String(date));
    console.log(String(date));
    return this.post(url_path, null, params);
  }
  //-------------------------- db sync restart ----------------------------------
  
  





  //------------------------------------------------------------------------------------//
  get(pathUrl:string, pathValue:string, param:URLSearchParams):Observable<any>{
    var url = this.srv_url + pathUrl;
    if(pathValue != null){ url = url + "/" + pathValue}
    let headers = new Headers();
    return this.http.get(url, {search :param, headers:headers, withCredentials: true})
      .map((res:Response) => this.getHttpResponse(res));
  }

  post(pathUrl:string,pathValue:string, param:URLSearchParams):Observable<any>{
    var url = this.srv_url + pathUrl;
    if(pathValue != null){ url = url + "/" + pathValue}
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'});
    let options = new RequestOptions({headers:headers, withCredentials: true});
    return this.http.post(url,param.toString(),options).map((res:Response) => res.json());

  }

  post_login(pathUrl:string,pathValue:string, param:URLSearchParams):Observable<any>{
    var url = this.srv_url + pathUrl;
    if(pathValue != null){ url = url + "/" + pathValue}
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded'});
    let options = new RequestOptions({headers:headers, withCredentials: true});
    return this.http.post(url,param.toString(),options).map((res:Response) => res);
  }

  post_requestBody(pathUrl:string, pathValue:string, body:any):Observable<any>{
    var url = this.srv_url + pathUrl;
    if(pathValue != null){ url = url + "/" + pathValue}
    let headers = new Headers({ 'content-Type': 'application/json;charset=utf-8'});
    let options = new RequestOptions({headers:headers, withCredentials: true});
    this.logger.debug("put >> : " , JSON.stringify(body));
    return this.http.post(url, JSON.stringify(body) , options).map((res:Response) => res.json());
  }

  put(pathUrl:string,pathValue:string, body:any):Observable<any>{
    var url = this.srv_url + pathUrl;
    if(pathValue != null){ url = url + "/" + pathValue}

    let headers = new Headers();
    headers.append('Content-Type', 'application/json;charset=utf-8');
    this.logger.debug("put >> : " , JSON.stringify(body));
    return this.http.put(url,JSON.stringify(body),{headers:headers , withCredentials: true})
      .map((res:Response) => res.json());
  }

  del(pathUrl:string,pathValue:string,param:URLSearchParams):Observable<any>{
    var url = this.srv_url + pathUrl;
    if(pathValue != null){ url = url + "/" + pathValue}
    let headers = new Headers({ 'content-Type': 'application/json;charset=utf-8'});
    return this.http.delete(url,{search :param, headers:headers, withCredentials: true})
      .map((res:Response) => res.json());
  }


  setSearchParam(page:number, max:number, search_text:string, search_field:string) : URLSearchParams {
    var p_params = new URLSearchParams();
    p_params.set('page', String(page));
    p_params.set('size', String(max));
    p_params.set('search_text', search_text);
    p_params.set('search_field', search_field);
    return p_params;
  }

  download(pathUrl:string,pathValue:string){
    var url = this.srv_url + pathUrl;
    if(pathValue != null){ url = url + "/" + pathValue}
    return this.http.get(url);
  }

  setPageParam(page:number, max:number) : URLSearchParams {
    var p_params = new URLSearchParams();
    p_params.set('page', String(page));
    p_params.set('size', String(max));
    return p_params;
  }
  // parameter set
  setParamHelper(params:any) : URLSearchParams {
    var p_param = new URLSearchParams();
    for(var key in params)  {
      var val = params[key];
      if(key == 'page' || key == 'max') {
        val = <string> val;
        p_param.set(key, val);
      } else {
        p_param.set(key, val);
      }
    }
    return p_param;
  }

  getHttpResponse(res:Response) : any {
    var http_status = res.status;
    var statusText  = res.statusText;
    if(http_status >= 100 && http_status < 200) {
      return this.get1xxHttpMessage(http_status);
    } else if(http_status >= 200 && http_status < 300) {
      //this.logger.debug("-->", res.json());
      return res.json();
    } else if(http_status >=300 && http_status < 400) {
      //this.logger.debug("--2");
      return this.get3xxHttpMessage(http_status);
    } else if(http_status >=400 && http_status < 500) {
      //this.logger.debug("--3");
      return this.get4xxHttpMessage(http_status);
    } else {
      //this.logger.debug("-->>>>>");
      return statusText;
    }
  }

  get1xxHttpMessage(code:number) : any {
    var resultMsg = '';
    switch(code) {
      case 100 : resultMsg = '요청자는 요청을 계속해야 한다. 서버는 이 코드를 제공하여 요청의 첫 번째 부분을 받았으며 나머지를 기다리고 있음을 나타낸다.'; break;
      case 101 : resultMsg = '요청자가 서버에 프로토콜 전환을 요청했으며 서버는 이를 승인하는 중이다.'; break;
      case 102 : resultMsg = '처리'; break;
    }
    return resultMsg;
  }

  get2xxHttpMessage(code:number) : any {
    var resultMsg = '';
    switch(code) {
      case 200 : resultMsg = '서버가 요청을 제대로 처리했다는 뜻이다. 이는 주로 서버가 요청한 페이지를 제공했다는 의미로 쓰인다.'; break;
      case 201 : resultMsg = '성공적으로 요청되었으며 서버가 새 리소스를 작성했다.'; break;
      case 202 : resultMsg = '서버가 요청을 접수했지만 아직 처리하지 않았다.'; break;
      case 203 : resultMsg = '서버가 요청을 성공적으로 처리했지만 다른 소스에서 수신된 정보를 제공하고 있다.'; break;
      case 204 : resultMsg = '서버가 요청을 성공적으로 처리했지만 콘텐츠를 제공하지 않는다.'; break;
      case 205 : resultMsg = '서버가 요청을 성공적으로 처리했지만 콘텐츠를 표시하지 않는다. 204 응답과 달리 이 응답은 요청자가 문서 보기를 재설정할 것을 요구한다(예: 새 입력을 위한 양식 비우기).'; break;
      case 206 : resultMsg = '서버가 GET 요청의 일부만 성공적으로 처리했다.'; break;
      case 207 : resultMsg = ''; break;
      case 208 : resultMsg = ''; break;
      case 226 : resultMsg = ''; break;
    }
    return resultMsg;
  }

  get3xxHttpMessage(code:number) : any {
    var resultMsg = "";
    switch(code) {
      case 300 : resultMsg = '서버가 요청에 따라 여러 조치를 선택할 수 있다. 서버가 사용자 에이전트에 따라 수행할 작업을 선택하거나, 요청자가 선택할 수 있는 작업 목록을 제공한다.'; break;
      case 301 : resultMsg = '요청한 페이지를 새 위치로 영구적으로 이동했다. GET 또는 HEAD 요청에 대한 응답으로 이 응답을 표시하면 요청자가 자동으로 새 위치로 전달된다.'; break;
      case 302 : resultMsg = '현재 서버가 다른 위치의 페이지로 요청에 응답하고 있지만 요청자는 향후 요청 시 원래 위치를 계속 사용해야 한다.'; break;
      case 303 : resultMsg = '요청자가 다른 위치에 별도의 GET 요청을 하여 응답을 검색할 경우 서버는 이 코드를 표시한다. HEAD 요청 이외의 모든 요청을 다른 위치로 자동으로 전달한다.'; break;
      case 304 : resultMsg = '마지막 요청 이후 요청한 페이지는 수정되지 않았다. 서버가 이 응답을 표시하면 페이지의 콘텐츠를 표시하지 않는다. 요청자가 마지막으로 페이지를 요청한 후 페이지가 변경되지 않으면 이 응답(If-Modified-Since HTTP 헤더라고 함)을 표시하도록 서버를 구성해야 한다.'; break;
      case 305 : resultMsg = '요청자는 프록시를 사용하여 요청한 페이지만 액세스할 수 있다. 서버가 이 응답을 표시하면 요청자가 사용할 프록시를 가리키는 것이기도 하다.'; break;
      case 307 : resultMsg = '현재 서버가 다른 위치의 페이지로 요청에 응답하고 있지만 요청자는 향후 요청 시 원래 위치를 계속 사용해야 한다.'; break;
      case 308 : resultMsg = '영구 리다이렉션, RFC에서 실험적으로 승인됨'; break;
    }

    return resultMsg;
  }


  get4xxHttpMessage(code:number) : any {
    var resultmsg = "";
    switch(code) {
      case 400 : resultmsg = "잘못된 요청"; break ;
      case 401 : resultmsg = "이 요청은 인증이 필요하다. 서버는 로그인이 필요한 페이지에 대해 이 요청을 제공할 수 있다."; break ;
      case 402 : resultmsg = "이 요청은 결제가 필요합니다."; break ;
      case 403 : resultmsg = "서버가 요청을 거부하고 있다."; break ;
      case 404 : resultmsg = "서버가 요청한 페이지를 찾을 수 없다"; break ;
      case 405 : resultmsg = "요청에 지정된 방법을 사용할 수 없다."; break ;
      case 406 : resultmsg = "요청한 페이지가 요청한 콘텐츠 특성으로 응답할 수 없다."; break ;
      case 407 : resultmsg = "이 상태 코드는 401(권한 없음)과 비슷하지만 요청자가 프록시를 사용하여 인증해야 한다. 서버가 이 응답을 표시하면 요청자가 사용할 프록시를 가리키는 것이기도 한다."; break ;
      case 408 : resultmsg = "서버의 요청 대기가 시간을 초과하였다."; break ;
      case 409 : resultmsg = "서버가 요청을 수행하는 중에 충돌이 발생했다. 서버는 응답할 때 충돌에 대한 정보를 포함해야 한다. 서버는 PUT 요청과 충돌하는 PUT 요청에 대한 응답으로 이 코드를 요청 간 차이점 목록과 함께 표시해야 한다."; break ;
      case 410 : resultmsg = "서버는 요청한 리소스가 영구적으로 삭제되었을 때 이 응답을 표시한다. 404(찾을 수 없음) 코드와 비슷하며 이전에 있었지만 더 이상 존재하지 않는 리소스에 대해 404 대신 사용하기도 한다. 리소스가 영구적으로 이동된 경우 301을 사용하여 리소스의 새 위치를 지정해야 한다."; break ;
      case 411 : resultmsg = "서버는 유효한 콘텐츠 길이 헤더 입력란 없이는 요청을 수락하지 않는다."; break ;
      case 412 : resultmsg = "서버가 요청자가 요청 시 부과한 사전조건을 만족하지 않는다."; break ;
      case 413 : resultmsg = "요청이 너무 커서 서버가 처리할 수 없다."; break ;
      case 414 : resultmsg = "요청 URI(일반적으로 URL)가 너무 길어 서버가 처리할 수 없다."; break ;
      case 415 : resultmsg = "요청이 요청한 페이지에서 지원하지 않는 형식으로 되어 있다."; break ;
      case 416 : resultmsg = "요청이 페이지에서 처리할 수 없는 범위에 해당되는 경우 서버는 이 상태 코드를 표시한다."; break ;
      case 417 : resultmsg = " 서버는 Expect 요청 헤더 입력란의 요구사항을 만족할 수 없다."; break ;
      case 418 : resultmsg = ""; break ;
      case 420 : resultmsg = ""; break ;
      case 422 : resultmsg = ""; break ;
      case 423 : resultmsg = ""; break ;
      case 424 : resultmsg = ""; break ;
      case 425 : resultmsg = ""; break ;
      case 426 : resultmsg = ""; break ;
      case 428 : resultmsg = ""; break ;
      case 429 : resultmsg = ""; break ;
      case 431 : resultmsg = "요청 헤더 필드가 너무 큼"; break ;
      case 444 : resultmsg = ""; break ;
      case 450 : resultmsg = ""; break ;
      case 451 : resultmsg = ""; break ;
      case 494 : resultmsg = ""; break ;
      case 495 : resultmsg = ""; break ;
      case 496 : resultmsg = ""; break ;
      case 497 : resultmsg = ""; break ;
      case 499 : resultmsg = "클라이언트가 요청을 닫음"; break ;
    }
    return resultmsg;
  }
  get5xxHttpMessage(code:number) : any {
    var resultmsg = "";
    switch(code) {
      case 500 : resultmsg = '서버에 오류가 발생하여 요청을 수행할 수 없다.'; break;
      case 501 : resultmsg = '서버에 요청을 수행할 수 있는 기능이 없다. 예를 들어 서버가 요청 메소드를 인식하지 못할 때 이 코드를 표시한다.'; break;
      case 502 : resultmsg = '서버가 게이트웨이나 프록시 역할을 하고 있거나 또는 업스트림 서버에서 잘못된 응답을 받았다.'; break;
      case 503 : resultmsg = '서버가 오버로드되었거나 유지관리를 위해 다운되었기 때문에 현재 서버를 사용할 수 없다. 이는 대개 일시적인 상태이다.'; break;
      case 504 : resultmsg = '서버가 게이트웨이나 프록시 역할을 하고 있거나 또는 업스트림 서버에서 제때 요청을 받지 못했다.'; break;
      case 505 : resultmsg = '서버가 요청에 사용된 HTTP 프로토콜 버전을 지원하지 않는다.'; break;
      case 506 : resultmsg = ''; break;
      case 507 : resultmsg = '용량 부족'; break;
      case 508 : resultmsg = '루프 감지'; break;
      case 509 : resultmsg = '대역폭 제한 초과'; break;
      case 510 : resultmsg = '확장되지 않음'; break;
      case 511 : resultmsg = '네트워크 인증 필요'; break;
      case 598 : resultmsg = '네트워크 읽기 시간초과 오류, 알 수 없음'; break;
      case 599 : resultmsg = '(네트워크 연결 시간초과 오류, 알 수 없음'; break;
    }
    return resultmsg;
  }

}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/service/mam_service.component.ts